<template>
  <section class="xiao-fei-zhe-dong-cha">
    <PageBlock title="消费者洞察">
      <div class="content">
        <div class="list">
          <div>消费热词</div>
          <div>性别结构</div>
          <div>年龄结构</div>
        </div>
        <div class="content-list">
<!--          <div v-for="(item, index) in hotWord" :key="index">{{item}}</div>-->
        </div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
import * as echarts from "echarts";

export default {
  name: 'xiao-fei-zhe-dong-cha',
  components: {PageBlock},
  props: {
    hotWord: Array,
    customerAnalysisList: Array,
  },
  data() {
    return {
      container: null,
      containerWidth: 0,
      containerHeight: 0,
      circles: []
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData () {
      this.container = document.querySelector('.content-list');
      this.containerWidth = this.container.offsetWidth;
      this.containerHeight = this.container.offsetHeight;
      this.circles = [];
      for (let i = 0; i < this.customerAnalysisList.length; i++) {
        this.createRandomCircle(this.customerAnalysisList[i].searchTerm);
      }
    },
    createRandomCircle(text) {
      const size = Math.floor(Math.random() * 31) + 30; // 大小在30到60之间
      let x, y;
      let overlap;

      do {
        // 生成随机位置
        x = Math.random() * (this.containerWidth - size);
        y = Math.random() * (this.containerHeight - size);
        overlap = this.circles.some(circle => {
          const distance = Math.sqrt(Math.pow(circle.x - x, 2) + Math.pow(circle.y - y, 2));
          return distance < (circle.size / 2 + size / 2);
        });
      } while (overlap);  // 检查重叠，重叠时重新生成位置

      const circle = document.createElement('div');
      circle.className = 'circle';
      circle.style.width = `${size}px`;
      circle.style.height = `${size}px`;
      circle.style.left = `${x}px`;
      circle.style.top = `${y}px`;
      circle.style.position = `absolute`;
      circle.style.borderRadius = `50%`;
      circle.style.backgroundColor = this.getRandomColor();  // 随机颜色
      circle.innerText = text
      circle.style.display = 'flex';
      circle.style.alignItems = 'center';
      circle.style.justifyContent = 'center';
      circle.style.color = '#fff';

      const fontSize = Math.floor(size / text.length * 0.7);  // 根据圆大小动态设置字体大小
      circle.style.fontSize = `${fontSize}px`;

      this.container.appendChild(circle);
      this.circles.push({ x, y, size });
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }
  },
};
</script>

<style scoped lang="scss">
.xiao-fei-zhe-dong-cha {
  .content{
    .list{
      display: flex;
      gap: 12px;
      font-size: 11px;
      color: #fff;
      >div{
        background: rgba(102, 255, 255, 0.17);
        padding: 3px 6px;
      }
    }
    .content-list{
      margin-top: 5px;
      border-radius: 12px;
      background: rgba(102, 255, 255, 0.17);
      padding: 12px 20px;
      //display: flex;
      //flex-wrap: wrap;
      //gap: 12px;
      height: 104px;
      position: relative;
      >div{
        color: #fff;
      }
      .circle {
        position: absolute;
        border-radius: 50%;
        background-color: rgba(0, 150, 255, 0.7);
      }
    }
  }
}
</style>
